import {
	AssignmentInd,
	Home,
	People,
	Report,
	Settings,
	AssignmentReturned,
} from "@material-ui/icons/";
import { DecodedJWT } from "../../utils";

const useSpeedDial = () => {
	const decoded = DecodedJWT();
	const RouteSpeedDial = [];

	if (decoded.dashboard_status) {
		RouteSpeedDial.push({
			path: "/dashboard",
			name: "Dashboard",
			icon: <Home />,
		});
	}

	if (decoded.role_master === 1) {
		RouteSpeedDial.push(
			{
				path: "/task",
				name: "Task",
				icon: <AssignmentInd />,
			},
			{
				path: "/users",
				name: "Users",
				icon: <People />,
			},
			{
				path: "/settings",
				name: "Settings",
				icon: <Settings />,
			},
			{
				path: "/log",
				name: "Log",
				icon: <Report />,
			}
		);
	}

	if (decoded.role_master === 2) {
		RouteSpeedDial.push({
			path: "/task",
			name: "Task",
			icon: <AssignmentInd />,
		});
	}

	if (decoded.report_status) {
		RouteSpeedDial.push({
			path: "/report",
			name: "Report",
			icon: <AssignmentReturned />,
		});
	}
	return { RouteSpeedDial };
};

export default useSpeedDial;
